export const URLS = {
  PUBLIC: {
    HERO_BG:
      "https://res.cloudinary.com/dlv7crxfz/image/upload/Hero_bg1_mpokkx.jpg",
    MAP_CAR_IMG:
      "https://res.cloudinary.com/dlv7crxfz/image/upload/v1757921464/Map_with_car_img_yhvvrm.jpg",
    BG2: "https://res.cloudinary.com/dlv7crxfz/image/upload/v1757925576/Bg_2_fcltki.jpg",
  },
  USER: {
    DASHBOARD: "",
  },
  DRIVER: {
    DASHBOARD: "d",
  },
  ADMIN: {
    DASHBOARD: "",
  },
  CLOUDINARY_BASE:
    "https://res.cloudinary.com/dlv7crxfz/image/upload/v1760611024/",
} as const;
